import {
  FolderGit2,
  Puzzle,
  Library,
  Container,
  Wrench,
  Cloud,
  Server,
  Boxes,
  SquareFunction,
  BrainCircuit,
  Notebook,
  Bot,
  Database,
  Warehouse,
  HardDrive,
  Camera,
  Archive,
  Zap,
  Network,
  MapPin,
  Scale,
  Plug,
  Shuffle,
  Cpu,
  Hexagon,
  Ship,
  Search,
  Radio,
  Folder,
  Globe,
  ChartColumn,
  Diamond,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * Knowledge-graph node type → lucide icon (Bedrock icon system — replaces the old
 * per-type emoji in graph-visuals). Keys mirror TYPE_EMOJI. Used both as JSX
 * (<NodeTypeIcon/>) and, via node-icon-img, as crisp data-URIs on the canvas.
 */
export const TYPE_ICON: Record<string, LucideIcon> = {
  repository: FolderGit2,
  'code.application': Puzzle,
  'code.dependency': Library,
  'container.image': Container,
  'iac.resource': Wrench,
  'cloud.account': Cloud,
  'compute.instance': Server,
  'compute.scaleset': Boxes,
  'compute.function': SquareFunction,
  'ml.endpoint': BrainCircuit,
  'ml.notebook': Notebook,
  'ml.model': Bot,
  database: Database,
  'warehouse.instance': Warehouse,
  'storage.volume': HardDrive,
  'storage.snapshot': Camera,
  'storage.bucket': Archive,
  'cache.cluster': Zap,
  'network.nat': Network,
  'network.address': MapPin,
  'network.loadbalancer': Scale,
  'network.endpoint': Plug,
  'network.gateway': Shuffle,
  'compute.workload': Cpu,
  'container.cluster': Hexagon,
  'container.workload': Ship,
  'search.cluster': Search,
  'streaming.cluster': Radio,
  'storage.filesystem': Folder,
  'network.cdn': Globe,
};

export const nodeTypeIcon = (type: string): LucideIcon => TYPE_ICON[type] ?? Diamond;

/** JSX node-type icon — replaces the old `emojiOf(type)` glyph in cost tables. */
export function NodeTypeIcon({ type, className }: { type: string; className?: string }) {
  const Icon = nodeTypeIcon(type);
  return <Icon aria-hidden className={cn('h-4 w-4 shrink-0', className)} />;
}

/** Cost-category (Compute / Databases / …) → lucide icon — replaces the old
 *  CATEGORY_EMOJI in graph-visuals. */
export const COST_CATEGORY_ICON: Record<string, LucideIcon> = {
  Compute: Server,
  Databases: Database,
  Cache: Zap,
  Storage: HardDrive,
  Networking: Network,
  Analytics: ChartColumn,
  'AI / ML': BrainCircuit,
  Account: Cloud,
};

export const costCategoryIcon = (category: string): LucideIcon =>
  COST_CATEGORY_ICON[category] ?? Diamond;

/** JSX cost-category icon — replaces the old `categoryEmoji(category)` glyph. */
export function CostCategoryIcon({
  category,
  className,
}: {
  category: string;
  className?: string;
}) {
  const Icon = costCategoryIcon(category);
  return <Icon aria-hidden className={cn('h-4 w-4 shrink-0', className)} />;
}
